import React from 'react'
import { ReactComponent as Livetv } from '../common/live_tv.svg'
export default function LiveTv() {
  return <Livetv></Livetv>
}
